import { Button, HStack } from '@chakra-ui/react';
import React, { FC, useState } from 'react';

import { Icon } from '@app/components/Icon';
import { PositionActionsModal } from '@app/screens/positions/components/PositionActionsModal';
import { Pair, Position } from '@app/types/pool';
import { useLocationContext } from '@app/context/LocationContext';
import { useIsHiddenPool } from '@app/hooks/pools/useIsHiddenPool';

interface Props {
  data: Position;
}

export const PositionControls: FC<Props> = ({ data }) => {
  const { isReadOnly } = useLocationContext();
  const [view, setView] = useState<{
    type: 'add' | 'withdraw';
    pair: Pair;
  } | null>(null);

  const isHiddenPool = useIsHiddenPool(data.pair.id);

  if (isReadOnly) {
    return null;
  }

  return (
    <>
      <HStack justify={['space-around', 'flex-end']} width="100%">
        <Button
          isDisabled={isHiddenPool}
          width={['100%', 'fit-content']}
          leftIcon={
            <Icon name="plusCircle" style={{ width: '20px', height: '20px' }} />
          }
          variant="secondary"
          onClick={() =>
            setView({
              type: 'add',
              pair: data.pair
            })
          }
        >
          Add
        </Button>
        <Button
          width={['100%', 'fit-content']}
          leftIcon={
            <Icon
              name="minusCircle"
              style={{ width: '20px', height: '20px' }}
            />
          }
          variant="secondary"
          onClick={() => {
            setView({
              type: 'withdraw',
              pair: data.pair
            });
          }}
        >
          Withdraw
        </Button>
      </HStack>
      <PositionActionsModal
        onClose={() => setView(null)}
        isOpen={view !== null}
        data={view}
        onChangeView={val => setView(val)}
      />
    </>
  );
};
